import styled from 'styled-components';
import { List } from '@alefeducation/ui-elements-library-core';

export const StyledListContainer = styled(List)`
  display: flex;
  flex-direction: column;
  height: auto;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }: any) => `${theme.space[8]}px`};
  border-bottom: 1px solid ${({ theme }: any) => theme.colors.primary[10]};

  padding: ${({ theme }) => theme.space[24]}px;
  padding-top: ${({ theme }) => theme.space[40]}px;
`;

export const flexStyle = ({ theme }: any) => `
  display: flex;
  flex-direction: column;
  row-gap: ${theme.space[16]}px;
`;

export const StyledTableSection = styled.div`
  ${flexStyle};
  border-bottom: 5px solid ${({ theme }: any) => theme.colors.primary[10]};
  padding: ${({ theme }) => `${theme.space[40]}px ${theme.space[24]}px`};
`;
